<template>
    <!-- 页脚部分 -->
    <footer class="footer-container">
        <div class="footer-content">
            <el-row :gutter="24" class="footer-row">
                <!-- 第一列内容 -->
                <el-col :span="6" class="footer-column">

                    <h3 class="footer-title">关于我们</h3>
                    <p class="footer-text">
                        芯棚到家（北京云智轩旗下品牌）致力于为农业提供智能化解决方案，助力农业数智化转型升级
                    </p>
                </el-col>

                <!-- 第二列内容 -->
                <el-col :span="6" class="footer-column">
                    <h3 class="footer-title">产品服务</h3>
                    <ul class="footer-list">
                        <li><a href="#" class="footer-link">智慧温室硬件产品</a></li>
                        <li><a href="#" class="footer-link">农业数据分析平台</a></li>
                        <li><a href="#" class="footer-link">智能农业管理ERP</a></li>
                        <li><a href="#" class="footer-link">物联网平台</a></li>
                    </ul>
                </el-col>

                <!-- 第三列内容 -->
                <el-col :span="6" class="footer-column">
                    <h3 class="footer-title">支持</h3>
                    <ul class="footer-list">
                        <li><a href="#" class="footer-link">技术文档</a></li>
                        <li><a href="#" class="footer-link">帮助中心</a></li>
                        <li><a href="javascript:;" class="footer-link" @click="scrollToContact">联系我们</a></li>
                    </ul>
                </el-col>

                <!-- 第四列内容 -->

                <el-col :span="6" class="footer-column">
                    <h3 class="footer-title">关注我们</h3>
                    <img :src="wechatUrl" alt="微信二维码" class="social-icon icon-img">
                </el-col>
            </el-row>

            <!-- 底部版权信息 -->
            <div class="copyright">
                <p>&copy; 2025北京云智轩科技有限公司.保留所有权利.</p>
                <a href="https://beian.miit.gov.cn/" target="_blank" class="RecordIcp">京ICP备2020040595号-2</a>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'MainFooter',
    data() {
        return {
            wechatUrl: require('@/assets/images/MainHomepage/公众号.png'),
            weiboUrl: require('@/assets/images/Footer/weibo.png'),
            linkedinUrl: require('@/assets/images/Footer/in.png')
        }
    },
    methods: {
        scrollToContact() {
            if (this.$route.path !== '/') {
                this.$router.push('/');
            }
            this.$nextTick(() => {
                const target = document.getElementById('contact-section');
                if (target) {
                    window.scrollTo({
                        top: target.offsetTop - 70,
                        behavior: 'smooth'
                    });
                }
            });
        }
    }
}
</script>

<style scoped>
/* 根容器：使用flex布局，高度占满屏幕 */
.page-container {
    min-height: 100vh;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
}

/* 内容区：自动填充剩余空间（将页脚挤到最底部） */
.content-wrapper {
    flex-grow: 1;
}

.footer-container {
    background-color: #1f2937;
    color: #9ca3af;
    padding: 3rem 0;
    margin-top: auto;
}

.footer-content {
    max-width: 1250px;
    margin: 0 auto;
    padding: 0 1rem;
}

.footer-row {
    margin-bottom: 2rem;
}

.footer-column {
    padding: 0 1rem;
    margin-bottom: 2rem;
}

.footer-title {
    color: #ffffff;
    font-weight: bold;
    margin-bottom: 1rem;
    font-size: 1.1rem;
}

.footer-text {
    font-size: 0.875rem;
    line-height: 1.5;
}

.footer-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.footer-list li {
    margin-bottom: 0.5rem;
}

.footer-link {
    color: #9ca3af;
    font-size: 0.875rem;
    text-decoration: none;
    transition: color 0.3s;
}

.footer-link:hover {
    color: #ffffff;
}

.social-icons {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
}

.social-icon {
    transition: transform 0.3s;
}

.social-icon:hover {
    transform: scale(1.1);
}

.icon-img {
    width: 10rem;
    height: 10rem;
    object-fit: contain;
}

.copyright {
    padding-top: 2rem;
    text-align: center;
    font-size: 0.875rem;
    margin-top: 5rem;
}

.custom-input::-webkit-outer-spin-button,
.custom-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.RecordIcp {
    color: #2563eb;
    text-decoration: none;
}

/* 手机设备样式 (小于768px) */
@media (max-width: 767px) {
    .footer-container {
        padding: 2rem 20px;
        width: 100%;
    }

    .footer-title {
        font-size: 1rem;
        margin-bottom: 0.75rem;
    }

    .footer-text,
    .footer-link,
    .copyright {
        font-size: 0.8rem;
    }

    .social-icons {
        gap: 0.75rem;
    }

    .icon-img {
        width: 10rem;
        height: 10rem;
    }

    .copyright {
        padding-top: 1.5rem;
    }
}

/* 平板设备样式  */
@media (min-width: 768px) and (max-width: 1368px) {
    .footer-column {
        margin-bottom: 1.5rem;
    }

    .logo-section {
        display: none !important;
    }

    .el-col-sm-12 {
        width: 25% !important;
    }

    .footer-title {
        font-size: 1.05rem;
    }

    .footer-text,
    .footer-link {
        font-size: 0.85rem;
    }
}

/* 大屏幕设备样式 (2560px - 3839px) */
@media (min-width: 2560px) and (max-width: 3839px) {
    .footer-content {
        max-width: 2000px;
    }

    .footer-container {
        padding: 4rem 0;
    }

    .footer-title {
        font-size: 1.5rem;
        margin-bottom: 1.5rem;
    }

    .footer-text,
    .footer-link {
        font-size: 1.1rem;
    }

    .footer-list li {
        margin-bottom: 0.75rem;
    }

    .social-icons {
        gap: 1.5rem;
        margin-top: 1.5rem;
    }

    .icon-img {
        width: 18rem;
        height: 18rem;
    }

    .copyright {
        padding-top: 3rem;
        font-size: 1rem;
    }
}

/* 超大型屏幕设备样式 (3840px及以上) */
@media (min-width: 3840px) {
    .footer-content {
        max-width: 3000px;
    }

    .footer-container {
        padding: 5rem 0;
    }

    .footer-title {
        font-size: 2rem;
        margin-bottom: 2rem;
    }

    .footer-text,
    .footer-link {
        font-size: 1.4rem;
    }

    .footer-list li {
        margin-bottom: 1rem;
    }

    .social-icons {
        gap: 2rem;
        margin-top: 2rem;
    }

    .icon-img {
        width: 25rem;
        height: 25rem;
    }

    .copyright {
        padding-top: 4rem;
        font-size: 1.25rem;
    }
}
</style>